import genericValidationMethods, { getValidationState } from './genericValidation';

export function BasicValidation() {
  this.rules = {
    personalEmail: {
      validationMethod: 'getEmailValidationState',
      errorMsg: 'Incomplete Personal Email',
      id: 'personalEmail'
    }
  };
  this.getEmailValidationState = genericValidationMethods.getEmailValidationState;
  this.getValidationStatus = getValidationState.bind(this);
}

export default BasicValidation;